import {read} from "@/api/rest";

const expertiseType = {
  index: async () => await read('/expertise-type'),
};

export default expertiseType;